<template>
  <div class="steps"
       :class="{ 'vertical': vertical }">
    <div
      v-for="(step, index) in stepItems"
      class="steps__step"
      :key="step.id"
      :class="{'is-active': (index + 1) === activeStep, 'was-active': (index + 1) < activeStep}">
      <div class="steps__stepNumber"> {{ index + 1 }} </div>
      <div class="steps__stepText"> {{ step.label }} </div>
    </div>
  </div>
</template>

<script>
export default {
name: "stepper-nav",
props: {
  stepItems: {
    type: Array,
    required: true,
    description: "An array of stepper items."
  },
  activeStep: {
    type: Number,
    required: true,
    default: 1,
    description: "Index of the active item."
  },
  readonly: {
    type: Boolean,
    required: false,
    default: true,
    description: "Whether the items are clickable or not."
  },
  vertical: {
    type: Boolean,
    default: false,
    description: "Vertical direction of stepper."
  }
},
}
</script>
<style lang="scss" scoped>

.steps {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;

  // 992px window width and more
  @include lg {
    flex-direction: row;
    margin: 0;
  }

  &.vertical {
    flex-direction: column;
  }

  &__step {
    $this: &;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;


    &:after  {
      // 992px window width and more
      @include lg {

      }

      @include rwd(992) {
        content: '';
        background: rgba($gray, .79);
        height: 1px;
        margin: 0 .5rem;
        flex-grow: 2;
      }

      @include rwd(1400) {
        margin: 0 1.5rem;
      }
    }

    &:last-child:after {
      content: none;
    }
    &Number {
      background: rgba($gray, .79);
      color: $white;
      width: 25px;
      height: 25px;
      min-width: 25px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: .8rem;
      margin-bottom: .25rem;

      // 992px window width and more
      @include lg {
        width: 22px;
        height: 22px;
        min-width: 22px;
        margin-bottom: 0;
      }

      @include rwd(992) {
        width: 30px;
        height: 30px;
        min-width: 30px;
        margin-bottom: 0;
      }

    }
    &Text {
      margin-left: .5rem;
      font-size: .9rem;
      color: rgba($gray, .85);

      @include lg {
        font-size: $font-size-xs;
      }

      @include rwd(992) {
        font-size: .9rem;
      }
    }
    &.is-active,
    &.was-active {
      #{$this}Number {
        background: #f60;
        color: white;
      }
      #{$this}Text {
        color: #f60;
      }
    }
  }
}
</style>

